const sanitizeExtension = (extension = '') =>
  extension
    .toString()
    .replace(/[^A-Za-z0-9]/g, '')
    .toUpperCase();

export const getDocumentExtension = (document, href) => {
  const extensionFromDocument = (document?.content_type ? document.content_type.split('/').pop() : '') || '';

  const sanitizedHref = href.split('#')[0].split('?')[0];
  const extensionFromHref = sanitizedHref.includes('.') ? sanitizedHref.split('.').pop() : '';

  return sanitizeExtension(extensionFromDocument || extensionFromHref || '');
};
